import { styled } from '@mui/system';

// Add styles for the role toggle container
export const RoleToggleContainer = styled('ul')(() => ({
  width: '100%',
  padding: 0,
  margin: 0,
  listStyle: 'none',
}));
